import {
  Flex,
  FlexItem,
  Icon60CancelCircle,
  MESSAGE_BOX_VARIANT_INFO,
  MessageBox,
  SPACING_24,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  Uploader,
  UPLOADER_VARIANT_DANGER,
  UPLOADER_VARIANT_DEFAULT,
  UPLOADER_VARIANT_UPLOADED,
  UPLOADER_VARIANT_UPLOADING,
  UploadingFile
} from 'mailup-web-components'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'

import styled from '@emotion/styled'
import {
  fileValidState,
  sourceState
} from 'Pages/SourceEdit/recoil/state/source'

import {
  getExtension,
  MIME_TYPE_CSV,
  NEW_EDIT_SOURCE_FILE_ACCEPT
} from 'Constants/index'
import { exportCallback } from 'Pages/SourceEdit/recoil/callbacks/callbacks'
import PropTypes from 'prop-types'

const StyledUploadedHint = styled.div`
  & > :last-child {
    font-size: 21px;

    svg path {
      stroke: var(--java);
      stroke-width: 2px;
    }
    & > :hover {
      svg path {
        stroke: var(--blue-chill);
      }
      cursor: ${({ showLink }) => (showLink ? 'default' : 'pointer')};
    }
  }
`

const Download = ({ firstString }) => {
  const exportFile = useRecoilCallback(exportCallback, [])

  const clickHandler = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    let el = e.target
    let foundClickOnHyperLink = false
    while (el && el !== e.currentTarget && el.tagName !== 'a') {
      el = el.parentNode
      foundClickOnHyperLink = true
    }
    if (foundClickOnHyperLink) {
      exportFile(MIME_TYPE_CSV)
    }
  }

  const createMarkup = (value) => {
    return { __html: value }
  }

  return (
    <div>
      <span
        onClick={clickHandler}
        dangerouslySetInnerHTML={createMarkup(firstString)}
      />
    </div>
  )
}

Download.propTypes = {
  firstString: PropTypes.string
}

const InputFile = () => {
  const intl = useIntl()
  const [
    {
      contentfile: { file, variant, warning }
    },
    setFileState
  ] = useRecoilState(sourceState)
  const isValidFile = useRecoilValue(fileValidState)

  const defaultInner = (
    <span>
      {intl.formatMessage({
        id: 'Load.ContentsSouces.FileUploaderTitle'
      })}{' '}
      <label htmlFor='input-email-file-id'>
        {intl.formatMessage({
          id: 'Load.ContentsSouces.fileUploaderBrowseLabel'
        })}
      </label>
    </span>
  )

  const value =
    variant === UPLOADER_VARIANT_UPLOADING ? (
      <UploadingFile
        name={file.name}
        size={`${intl.formatNumber(file.size)} KB`}
      />
    ) : undefined

  let hint =
    variant === UPLOADER_VARIANT_DANGER ? (
      intl
        .formatMessage({
          id: 'Load.ContentsSouces.fileUploaderDescription'
        })
        .replace('{Y}', '5')
    ) : variant === UPLOADER_VARIANT_UPLOADED ? (
      <StyledUploadedHint showLink={warning}>
        <Flex alignItems='center' justifyContent='center'>
          <Text variant={TEXT_VARIANT_BOLD}>{file && file.name}</Text>

          <FlexItem margin='0 0 0 8px'>
            <div
              onClick={() => {
                if (!warning) {
                  setFileState((prev) => ({
                    ...prev,
                    contentfile: {
                      ...prev.contentfile,
                      isDirty: false,
                      variant: UPLOADER_VARIANT_DEFAULT,
                      file: undefined
                    }
                  }))
                }
              }}
            >
              {!warning && <Icon60CancelCircle />}
            </div>
          </FlexItem>
        </Flex>
      </StyledUploadedHint>
    ) : (
      intl.formatMessage({
        id: 'Load.ContentsSouces.fileUploaderDescription'
      })
    )

  useEffect(() => {
    if (file) {
      if (isValidFile) {
        // upload
        setFileState((prev) => ({
          ...prev,
          contentfile: {
            ...prev.contentfile,
            variant: UPLOADER_VARIANT_UPLOADED
          }
        }))
      } else {
        setFileState((prev) => ({
          ...prev,
          contentfile: {
            ...prev.contentfile,
            variant: UPLOADER_VARIANT_DANGER
          }
        }))
        hint = intl
          .formatMessage({
            id: 'Load.ContentsSouces.fileUploaderDescription'
          })
          .replace('{Y}', '5')

        setTimeout(() => {
          // se è ancora DANGER la resetto
          setFileState((prev) => ({
            ...prev,
            contentfile: {
              ...prev.contentfile,
              variant: UPLOADER_VARIANT_DEFAULT
            }
          }))
        }, 5000)
      }
    }
  }, [file])

  const handleChange = (e) => {
    setFileState((prev) => ({
      ...prev,
      isDirty: true,
      contentfile: {
        ...prev.contentfile,
        isDirty: true,
        file: e && e.length > 0 ? e[0] : {}, // {} oggetto vuoto scatena il danger dello useEffect,
        extension: e && e.length > 0 ? getExtension(e[0].name) : '',
        variant: UPLOADER_VARIANT_UPLOADING
      }
    }))
  }

  return (
    <>
      <MessageBox variant={MESSAGE_BOX_VARIANT_INFO}>
        <Download
          firstString={intl.formatMessage({
            id: 'Load.ContentsSouces.InfoUploadFileNew'
          })}
        />
      </MessageBox>
      <SpacingVertical variant={SPACING_24} />

      <Uploader
        multiple={false}
        variant={variant}
        accept={NEW_EDIT_SOURCE_FILE_ACCEPT}
        onChange={(e) => handleChange(e)}
        inputId='input-email-file-id'
        value={value}
        hint={hint}
      >
        {defaultInner}
      </Uploader>
    </>
  )
}

export default InputFile
